module.exports = __webpack_public_path__ + "static/media/window-frame-open.53c9eef3.svg";